$(document).ready(function() {

    $(document).on("click", '.js_tag__checkbox', function(e) {
        e.preventDefault();
        console.log('tst')
        var checkbox = $(this).closest('label').find('input[type="checkbox"]');
        var newState = !checkbox.prop("checked");

        checkbox.prop("checked", newState);

        var result = [];
        $('.js_color').each(function() {
            var value = $(this).attr('filter-value').replace(/\s+/g, '+'); // Replace spaces with '+'
            result.push(value);
        });

        var matchingValues = [];
        $('.js_filter_redirect:checked').each(function() {
            var valueToCheck = $(this).attr('data-filter').replace(/\s+/g, '+'); // Replace spaces with '+'
            console.log("Test Favorite Color : " + valueToCheck);

            console.log("Checking for matching values in the array:");
            for (var i = 0; i < result.length; i++) {
                if (result[i].includes(valueToCheck)) {
                    matchingValues.push(result[i]);
                    console.log(matchingValues);
                    console.log(matchingValues[matchingValues.length - 1]);
                } else {

                }
            }
        });


        var urlParameters = '';
        if (matchingValues.length > 0) {
            urlParameters = matchingValues.map(function(value) {
                return 'filter.v.option.colour=' + value;
            }).join('&');
            console.log('URL Parameters for matched values:', urlParameters);
        }

        var currentUrl = window.location.toString();
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('filter.v.option.colour')) {
            urlParams.delete('filter.v.option.colour');
        }
        var updatedUrl = currentUrl.split('?')[0] + '?' + urlParams.toString();
        if (urlParameters !== '') {
            updatedUrl += (urlParams.toString() !== '' ? '&' : '') + urlParameters;
        }
        console.log('Complete URL:', updatedUrl);

        $('#FilterDrawer').removeClass('drawer--is-open');
        if (!$(this).data('ajax_in_progress')) {
            $(this).data('ajax_in_progress', true);
            $.ajax({
                url: updatedUrl,
                success: function(htmlData) {
                    window.history.pushState({
                        path: updatedUrl
                    }, '', updatedUrl);
                    let html_markup = $(htmlData);
                    let to_replace = html_markup.find('.js_test').html();
                    let colFilter = html_markup.find('.filter-form').html();
                    $('#collection').html(htmlData);
                    window.history.pushState({
                        path: updatedUrl
                    }, '', updatedUrl);
                    $('.tag__checkbox').closest('label').find('input[type="checkbox"]');
                    $('html, body').animate({
                        scrollTop: $("#collection").offset().top - 330
                    }, 180);
                    let activeFilterCount = $('.custom-active-filter').length;
                    $('.active_filter_count').text(activeFilterCount);
                    $('#shopify-section-header').after(`<div class="top-feature-sec">
                    <div class="page-width top-feature-container">
                      <div class="top-feature-list desktop">
                        <div class="top-feature-list-main-flex">
                          
                          <div class="top-feature-list-flex">
                            <div class="top-feature-list-image">
                          <img src="https://cdn-3.convertexperiments.com/uf/10041529/10046507/Tick.png">	
                          </div>
                          <div class="top-feature-list-title desktop">
                            <span>HASSLE FREE PAYMENTS</span>  via Klarna, Paypal or Clearpay 
                          </div>
                          <div class="top-feature-list-title mobile">
                            <span>HASSLE FREE PAYMENTS</span>
                          </div>
                          </div>
    
                          <div class="top-feature-list-flex">
                            <div class="top-feature-list-image">
                          <img src="https://cdn-3.convertexperiments.com/uf/10041529/10046507/Tick.png">	
                          </div>
                          <div class="top-feature-list-title">
                            Free UK shipping on orders over £50
                          </div>
                          </div>
    
                          <div class="top-feature-list-flex">
                            <div class="top-feature-list-image">
                          <img src="https://cdn-3.convertexperiments.com/uf/10041529/10046507/Tick.png">	
                          </div>
                          <div class="top-feature-list-title">
                            30 day return policy
                          </div>
                          </div>
                        </div>
                      </div>
    
                      <div class="top-feature-list mobile">
                  <div class="swiper swiper-top-feature swiper-initialized swiper-horizontal">
                    <div class="swiper-wrapper" id="swiper-wrapper-77eec412bd4621001" aria-live="polite" style="transition-duration: 0ms; transition-delay: 0ms;">
                      <!-- Slides -->
                        <div class="swiper-slide">
                        <div class="top-feature-list-flex">
                            <div class="top-feature-list-image">
                          <img src="https://cdn-3.convertexperiments.com/uf/10041529/10046507/Tick.png">	
                          </div>
                          <div class="top-feature-list-title">
                            Free UK shipping on orders over £50
                          </div>
                          </div>
                      </div>
                      <div class="swiper-slide">
                        <div class="top-feature-list-flex">
                            <div class="top-feature-list-image">
                          <img src="https://cdn-3.convertexperiments.com/uf/10041529/10046507/Tick.png">	
                          </div>
                          <div class="top-feature-list-title">
                            <span>HASSLE FREE PAYMENTS</span> 
                          </div>
                          </div>
                      </div>
    
                    
    
                      <div class="swiper-slide">
                        <div class="top-feature-list-flex">
                            <div class="top-feature-list-image">
                          <img src="https://cdn-3.convertexperiments.com/uf/10041529/10046507/Tick.png">	
                          </div>
                          <div class="top-feature-list-title">
                            30 day return policy
                          </div>
                          </div>
                      </div>
                    
                    </div>
                  
                    <div class="swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-77eec412bd4621001" aria-disabled="false">
                      <img src="https://cdn-3.convertexperiments.com/uf/10041529/10046507/nav1.png" class="top-ft-img">
                    </div>
                    <div class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-77eec412bd4621001" aria-disabled="false">
                      <img src="https://cdn-3.convertexperiments.com/uf/10041529/10046507/nav2.png" class="top-ft-img">
                    </div>
    
                  <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>
                      </div>
                    </div>
                  </div>`);
                },
                error: function(xhr, status, error) {
                    console.error('Error loading data:', error);
                },
                complete: function() {
                    $(this).data('ajax_in_progress', false);
                }
            });
        }
        let activeFilterCount = $('.custom-active-filter').length;
        $('.active_filter_count').text(activeFilterCount);
    });
    $(document).on("click", "#remove_black", function(e) {
        e.preventDefault();
        $("#black_filter").click();
    });
    $(document).on("click", "#remove_blue", function(e) {
        e.preventDefault();
        $("#blue_filter").click();
    });
    $(document).on("click", "#remove_brown", function(e) {
        e.preventDefault();
        $("#brown_filter").click();
    });
    $(document).on("click", "#remove_green", function(e) {
        e.preventDefault();
        $("#green_filter").click();
    });
    $(document).on("click", "#remove_grey", function(e) {
        e.preventDefault();
        $("#grey_filter").click();
    });
    $(document).on("click", "#remove_pink", function(e) {
        e.preventDefault();
        $("#pink_filter").click();
    });
    $(document).on("click", "#remove_white", function(e) {
        e.preventDefault();
        $("#white_filter").click();
    });
    $(document).on("click", "#remove_red", function(e) {
        e.preventDefault();
        $("#red_filter").click();
    });
});
$(document).on("click", '.js_tag_text', function(e) {
    e.preventDefault();
    var checkbox = $(this).closest('label').find('.js_tag__checkbox');
    setTimeout(function() {
        checkbox.click();
    }, 10); // Adjust the delay time as needed
});